<template>
    <main>
        <div class="common-report customer-engagement-view">
            <customer-engagement-relation/>
            <customer-engagement-allocation/>
        </div>
    </main>
</template>

<script>
    const CustomerEngagementRelation = () =>
        import("./customer-engagement/CustomerEngagementRelation");
    const CustomerEngagementAllocation = () =>
        import("./customer-engagement/CustomerEngagementAllocation");
    import settings from "../../../config/settings";
    export default {
        name: "CustomerEngagement",
        components: {CustomerEngagementAllocation, CustomerEngagementRelation},
        computed: {
            filter: function () {
                return this.$store.state.reports.customerEngagementFilter;
            }
        },
        beforeMount() {
            
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                // update the filter data to inital page count
                 let filter = _.cloneDeep(this.filter);
                filter.pageSize = settings.initial_forecast_row_count;
                filter.pageNumber = 1;
                this.$store.dispatch("fetchCustomerEngagementReport", filter);
                this.$store.dispatch("fetchReportAggregates",filter);
            }
        }
    };
</script>

<style scoped>
</style>